import { ConnectorAppendixProps } from './Appendix.proptype';
import { Appendix as Component } from './component';
import { Connector } from './connector';

export interface AppendixGenerateProps extends Omit<ConnectorAppendixProps, 'component'> {}

export const Appendix = (props: AppendixGenerateProps) => <Connector {...props} component={Component} />;
